
import React from "react";

export const LoginDivider = () => {
  return (
    <div className="relative my-8">
      <div className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-gray-700"></div>
      </div>
      <div className="relative flex justify-center text-xs uppercase">
        <span className="bg-[#1A1A1A] px-2 text-gray-400">ODER ANMELDEN MIT</span>
      </div>
    </div>
  );
};
